import create from '../creator'
import axios from '@/wrapper'
import jwtStore from '@/utils/localStorageJwt'
import { isStringSet } from '@/utils'

const initialState = () => ({
  queryParams: {
    currency: '',
    amount: 0,
  },
  transaction: {
    status: undefined,
    id: undefined,
    acquirerCode: '',
  },
  absaPayInputType: 'SAID',
  capitecPayInputType: 'CELLPHONE',
  processingNedbankPayTransaction: false,
  timeToLive: null,
  showCancel: true,
  showBodyOnly: false,
  hideContent: true,
})
const _state = initialState()

const actions = {
  async createTransaction({ commit }, transaction) {
    const resp = await axios.post(`v30/transactions`, transaction)

    var jwtIdentity = resp.headers['jwtidentity']
    if (jwtIdentity != null) {
      jwtStore.set(resp.data.id, jwtIdentity)
    }
    commit('setTransaction', resp.data)
    commit('setShowBodyOnly', resp.data.theme)
    commit('setHideContent')
    return resp.data
  },

  async getTransaction({ commit }, { transactionId, retries = 0 }) {
    const resp = await axios.get(
      `v30/transactions/${transactionId}`,
      {},
      {},
      { transactionId, retries }
    )
    commit('setTransaction', resp.data)
    commit('setShowBodyOnly', resp.data.theme)
    commit('setHideContent')
    return resp.data
  },

  async getTransactionReload({ commit }, { transactionId }) {
    const resp = await axios.get(
      `v30/transactions/transactionReload/${transactionId}`,
      {},
      {},
      { transactionId }
    )

    commit('setTransaction', resp.data.transaction)
    commit('setShowBodyOnly', resp.data.transaction.theme)
    commit('setHideContent')
    return resp.data
  },

  async updateTransaction({ commit }, { transactionId, data }) {
    const resp = await axios.post(
      `v30/transactions/${transactionId}/acquirer`,
      data,
      {},
      { transactionId }
    )
    commit('updateTransaction', resp.data)
    return resp.data
  },

  // eslint-disable-next-line no-empty-pattern
  async openMerchant({ formData, url }) {
    const resp = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return resp.data
  },
  setAbsaPayInputType({ commit }, data) {
    commit('updateAbsaPayInputType', data)
  },
  setCapitecPayInputType({ commit }, data) {
    commit('updateCapitecPayInputType', data)
  },
  setTimeToLive({ commit }, data) {
    commit('updateTimeToLive', data)
  },
  setShowCancel({ commit }, data) {
    commit('updateShowCancel', data)
  },
}

const mutations = {
  setTransaction(state, transaction) {
    state.transaction = transaction
  },

  updateTransaction(state, transaction) {
    state.transaction = transaction
  },
  updateCapitecPayInputType(state, inputType) {
    state.capitecPayInputType = inputType
  },
  updateAbsaPayInputType(state, inputType) {
    state.absaPayInputType = inputType
  },
  updateTimeToLive(state, ttl) {
    state.timeToLive = ttl
  },
  updateShowCancel(state, showCancel) {
    state.showCancel = showCancel
  },
  setShowBodyOnly(state, theme) {
    state.showBodyOnly = isStringSet(theme)
  },
  setHideContent(state, hide = false) {
    state.hideContent = hide
  },
}

export default create(
  {
    namespaced: true,
    state: _state,
    actions,
    mutations,
  },
  initialState()
)
